import executeApi from 'shared/executeApi';
import { fetchAuthSession } from 'aws-amplify/auth';
import { SystemError } from "../constants";

/** 帳票出力 */
const createPdf = async (
    requestObj: { [key: string]: any }
) => {
    // 認証
    const session = await fetchAuthSession();
    const jwtToken = session.tokens?.idToken?.toString();
    // SmeFrontAPIのURLを取得
    const baseURL = process.env.REACT_APP_SME_FRONT_API_ROOT!;
    // 帳票出力API PATH
    const path = "/finance/createPdf/execution";
    const request = JSON.stringify(requestObj)

    try {
        const response: any = await executeApi(baseURL, path, jwtToken, 0, request);
        // ダウンロード実行
        const url = response.data.data.url;
        if (url !== "") {
            let link = document.createElement('a');
            link.download = url;
            link.href = url;
            link.click();
        }
        // レスポンスコード返却
        if (!response || response.data.res_cd == "") {
          return SystemError
        } else {
          return response.data.res_cd
        }
    } catch (e) {
        return SystemError;
    }
};

export default createPdf;
